import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, AlertTriangle } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0C0E14] border-t border-[#1E2532]" data-testid="footer">
      {/* Legal Disclaimer Banner */}
      <div className="bg-[#111621] border-b border-[#1E2532]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-start space-x-3">
            <AlertTriangle className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-0.5" />
            <div className="text-xs text-[#A1A7B5]" data-testid="legal-disclaimer">
              <p className="font-semibold text-yellow-500 mb-1">LEGAL DISCLAIMER - FOR RESEARCH USE ONLY</p>
              <p>
                All products sold by RENEW LABS are intended for laboratory and research purposes only. 
                They are not intended for human or veterinary use, consumption, or application. 
                These products are not drugs, foods, cosmetics, or dietary supplements and have not been 
                evaluated or approved by the FDA for any purpose. By purchasing from RENEW LABS, you acknowledge 
                that you are a qualified researcher or are purchasing on behalf of a research institution, 
                and that you will not use these products for any unauthorized purposes. The buyer assumes 
                all responsibility for the legal and safe use of these products.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-2">
              <span className="font-bold text-2xl text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>
                RENEW<span className="text-[#00F0FF]">|</span>LABS
              </span>
            </Link>
            <p className="text-[#A1A7B5] text-sm">
              Precision science for breakthrough discoveries. Lab-grade purity, unparalleled quality.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/renew.labs" target="_blank" rel="noopener noreferrer" className="text-[#A1A7B5] hover:text-[#00F0FF] transition-colors" data-testid="social-instagram">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/products" className="text-[#A1A7B5] hover:text-[#00F0FF] transition-colors text-sm">Products</Link></li>
              <li><Link to="/about" className="text-[#A1A7B5] hover:text-[#00F0FF] transition-colors text-sm">About Us</Link></li>
              <li><Link to="/track" className="text-[#A1A7B5] hover:text-[#00F0FF] transition-colors text-sm">Track Order</Link></li>
              <li><Link to="/affiliate" className="text-[#A1A7B5] hover:text-[#00F0FF] transition-colors text-sm">Become an Affiliate</Link></li>
            </ul>
          </div>

          {/* Research */}
          <div>
            <h4 className="text-white font-semibold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Research</h4>
            <ul className="space-y-2">
              <li><Link to="/products" className="text-[#A1A7B5] hover:text-[#00F0FF] transition-colors text-sm">All Peptides</Link></li>
              <li><Link to="/products?search=BPC" className="text-[#A1A7B5] hover:text-[#00F0FF] transition-colors text-sm">BPC-157</Link></li>
              <li><Link to="/products?search=Semaglutide" className="text-[#A1A7B5] hover:text-[#00F0FF] transition-colors text-sm">Semaglutide</Link></li>
              <li><Link to="/products?search=Bacteriostatic" className="text-[#A1A7B5] hover:text-[#00F0FF] transition-colors text-sm">Bacteriostatic Water</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3 text-[#A1A7B5] text-sm">
                <Mail className="w-4 h-4 text-[#00F0FF]" />
                <span>support@getrenewlabs.com</span>
              </li>
              <li className="flex items-center space-x-3 text-[#A1A7B5] text-sm">
                <Phone className="w-4 h-4 text-[#00F0FF]" />
                <span>(817) 803-8745</span>
              </li>
              <li className="flex items-start space-x-3 text-[#A1A7B5] text-sm">
                <MapPin className="w-4 h-4 text-[#00F0FF] mt-0.5" />
                <span>8074 Precinct Ln Rd, Colleyville, TX 76034</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#1E2532] mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-[#A1A7B5] text-sm">
            © 2026 RENEW LABS. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="text-[#A1A7B5] hover:text-[#00F0FF] text-sm transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-[#A1A7B5] hover:text-[#00F0FF] text-sm transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
